import React from 'react'
import RequestTable from './RequestTable'

function RequestComponent(props) {
  return (
    <div className="content-line">
      <div className="line line-100">
        <RequestTable list={props.state.control.rows} go={props.onChangeRoute} />
      </div>
    </div>
  )
}

export default RequestComponent
